/**
 * The admin view, now backed by an account.
 *
 * This used to read `?superadmin=1` from the URL and remember it for the
 * tab. That was honest about what it was -- presentation, not access
 * control, with every hidden number still in the API responses -- but it
 * kept no secret from anyone who could type.
 *
 * The hook keeps its name and its meaning ("should the quality, gaps and job
 * surfaces be shown"), so the sixteen components that consume it did not
 * change. What changed is where the answer comes from: the signed-in user's
 * role, enforced independently by the server, which now refuses
 * `/api/admin/*` to a viewer regardless of what the client renders.
 */
export { useIsAdmin as useSuperadmin } from './auth.tsx'

/**
 * Kept as a no-op so `main.tsx` need not special-case the transition.
 *
 * If a bookmark still carries `?superadmin=1`, stripping it silently is the
 * right behaviour: the parameter no longer grants anything, and leaving it
 * in the address bar would suggest it still might.
 */
export function applySuperadminFromUrl(): void {
  try {
    const url = new URL(window.location.href)
    if (!url.searchParams.has('superadmin')) return
    url.searchParams.delete('superadmin')
    window.history.replaceState(null, '', url.pathname + (url.search || '') + url.hash)
  } catch { /* a URL we cannot parse is not one we act on */ }
}
